






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoaderOverlay extends Vue {
  @Prop({ default: 64 }) private readonly size!: number;
}
